// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pu_a bhy_ea bhy_ke bhy_ju bhy_a bhy_j bhy_so bhy_sp","SearchPanel__icon":"pu_b bhy_vo bhy_hi bhy_su bhy_va","SearchPanel__input":"pu_c bhy_jb bhy_eg bhy_z"};